import { Component } from 'react';
import { ILobbyState } from '../../../Core/State/ILobbyState';
import { IRoomState } from '../../../Core/State/IRoomState';
import { IUserState } from '../../../Core/State/IUserState';
import styles from '../../../assets/css/components/MobileLobby.module.css';
import { createTheme, Stack, ThemeProvider } from '@mui/material';
import MobileHeader from '../../Header/MobileHeader';
import MobileRoomBar from '../../RoomBar/MobileRoomBar';
import MobileTableRow from '../Common/MobileTableRow';
import tableImageLow from '/images/table/mobile-game-table-low.svg';
import tableImageMid from '/images/table/mobile-game-table-mid.svg';
import tableImageHigh from '/images/table/mobile-game-table-high.svg';

interface LobbyProps {
    joinRoom: (roomId: string) => void;
    setSection: (section: string) => void;
    userState: IUserState;
    lobbyState: ILobbyState;
    selectedRoomId: string | null;
    section: string;
    joinedRoomsState: any[];
    logout: () => void;
    userConnectedCount: number;
}

interface LobbyState {
    selectedRoom: IRoomState | null;
}

export default class MobileAofLobby extends Component<LobbyProps, LobbyState> {

    constructor(props: LobbyProps) {
        super(props);
        this.state = {
            selectedRoom: null
        };
    }

    darkTheme = createTheme({
        palette: {
            mode: "dark",
            primary: {
                main: "#F93751",
            },
        },
        typography: {
            fontFamily: 'Inter, serif',
        },
    });

    componentDidMount(): void {
        const tableImages = [tableImageLow, tableImageMid, tableImageHigh];
        tableImages.forEach((image: string) => {
            const img = new Image();
            img.src = image;
        });
    }

    componentDidUpdate(prevProps: LobbyProps) {
        if (this.state.selectedRoom && prevProps.lobbyState !== this.props.lobbyState) {
            const updatedRoom = this.props.lobbyState.rooms.find(room => room.roomId === this.state.selectedRoom?.roomId);
            if (updatedRoom) {
                this.setState({ selectedRoom: updatedRoom });
            }
        }
    }

    render() {
        // Update the filtering to only show aof rooms
        const fiatRooms = this.props.lobbyState.rooms.filter(room => 
            room.type === 'aof' && room.currencyType === 'fiat'
        );
        const cryptoRooms = this.props.lobbyState.rooms.filter(room =>
            room.type === 'aof' && room.currencyType === 'crypto'
        );
        const filteredRooms = [...fiatRooms, ...cryptoRooms];
        // Sort rooms by playerSatCount, descending
        filteredRooms.sort((a, b) => b.playerSatCount - a.playerSatCount);

        return (
            <ThemeProvider theme={this.darkTheme}>
                <Stack className={styles.mobileLobby}>
                    <MobileHeader 
                        userState={this.props.userState}
                        section={this.props.section}
                        logout={this.props.logout}
                    />
                    <MobileRoomBar
                        userConnectedCount={this.props.userConnectedCount}
                    />
                    <Stack spacing={1} className={styles.mobileLobbyTables}>
                        {filteredRooms.map((table) => (
                            <MobileTableRow key={table.roomId} table={table} joinedRoomsState={this.props.joinedRoomsState} joinRoom={this.props.joinRoom} userState={this.props.userState} />
                        ))}
                    </Stack>
                </Stack>
            </ThemeProvider>
        );
    }
}
